import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import {
  ChevronUp,
  PlusCircle,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../core/redux/action";
import Table from "../../core/pagination/datatable";
import Axios from "axios";
import { useEffect } from "react";
import { setbookedsolditems_data } from "../../core/redux/action";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  API_BASE_URL,
  GET_ORDERS,
  GET_VSTORE_PROD,
  INSERT_ORDERS,
} from "../../Config";
import { getUserPermissions } from "../../UserPermissions";
import Select from "react-select";
import Swal from "sweetalert2";
import SpinLoader from "../loader/SpinLoader";

const BookedSoldItem = () => {
  const [userDataSession, setUserDataSession] = useState({});
  const [productsData, setProductsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  // const [selectedCustomer, setSelectedCustomer] = useState("WalkIn");
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  const [permissions, setPermissions] = useState({
    isRead: "d-none",
    isWrite: "d-none",
    isDelete: "d-none",
    isExport: "d-none",
  });

  useEffect(() => {
    const perms = getUserPermissions("Categories");
    setPermissions(perms);
  }, []);

  const data = useSelector((state) => state.toggle_header);

  const dispatch = useDispatch();
  const dataSource = useSelector((state) => state.bookedsolditems_data) || [];
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && userDataSession.UserId) {
      setLoading(true);

      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: 0,
        BarCode: "0",
        ProductId: 0,
        StoreId: 0,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 0,
      };

      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          if (response.data.Status) {
            setProductsData(response.data.ResultData);
            // setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            // setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          //   setLoading(false);
        });
    }
  }, [userDataSession]);

  const handleProductSelect = (selectedOption) => {
    const product = selectedOption.value;

    // Map to your desired field names
    const transformedProduct = {
      value: product.Id, // Use the product's Id as the unique identifier
      label: product.ProductName, // Display label for the Select option
      weight: product.SoldbyWeight ? 1 : 0, // Example: Map SoldbyWeight to a Yes/No value
      price: product.AvgPrice, // Use AvgPrice as the price
      quantity: 1, // Default quantity
      barcode: product.BarCode, // Include BarCode
      category: product.CategoryName, // Include Category Name
      imagePath: product.ImagePath, // Include Image Path
    };

    setSelectedProduct((prevSelected) => [...prevSelected, transformedProduct]);
  };

  // useEffect(() => {
  //     if (userDataSession && userDataSession.OrgId) {
  //         setLoading(true);
  //         Axios.get(`${API_BASE_URL}${GET_DELIVERY_CHALLAN}?OrgId=${userDataSession.OrgId}`)
  //             .then(response => {
  //                 if (response.data.Status) {
  //                     dispatch(setbookedsolditems_data(response.data.ResultData));
  //                     setLoading(false);
  //                 } else {
  //                     console.error('Error fetching data:', response.data.Message);
  //                     setLoading(false);
  //                 }
  //             })
  //             .catch(error => {
  //                 console.error('Error fetching data:', error);
  //                 setLoading(false);
  //             });
  //     }
  // }, [dispatch, userDataSession]);

  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const formatDate = (date) => date.toISOString().split("T")[0];
  const [mobileNumber, setMobileNumber] = useState("");

  useEffect(() => {
    const handelSearchClick = () => {
      // e.preventDefault();

      if (userDataSession && userDataSession.OrgId) {
        setLoading(true);

        Axios.get(`${API_BASE_URL}${GET_ORDERS}`, {
          params: {
            OrgId: userDataSession.OrgId,
            STdt: formatDate(startOfMonth),
            enddt: formatDate(endOfMonth),
            PosId: 0,
            StoreId: 0,
            OrderNo: "NULL",
          },
        })
          .then((response) => {
            console.log(
              response.data,
              "response.data.ResultDataresponse.data.ResultData"
            );
            if (
              response.data.Status &&
              Array.isArray(response.data.ResultData) &&
              response.data.ResultData.length > 0
            ) {
              if (response.data.ResultData[0].Status !== "Failure") {
                dispatch(setbookedsolditems_data(response.data.ResultData));
              } else {
                console.error(
                  "Error fetching data:",
                  response.data.ResultData[0].ResultMessage
                );
                // setOrdersData([]);
              }
            } else {
              // setOrdersData([]);
            }
            setLoading(false);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
            setLoading(false);
            // setOrdersData([]);
          });
      }
    };
    handelSearchClick();
  }, [dispatch, userDataSession]);

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const columns = [
    {
      title: "Order No",
      dataIndex: "OrderNo",
      sorter: (a, b) => a.OrderNo.localeCompare(b.OrderNo),
    },
    {
      title: "Date",
      dataIndex: "OrderDate",
      sorter: (a, b) => new Date(a.OrderDate) - new Date(b.OrderDate),
      render: (text) => {
        const date = new Date(text);
        return date.toLocaleDateString("en-GB");
      },
    },
    {
      title: "Customer",
      dataIndex: "Comments",
      sorter: (a, b) => a.CustomerName.localeCompare(b.CustomerName),
      render: (text) => text || "N/A",
    },

    {
      title: "Total",
      dataIndex: "Total",
      sorter: (a, b) => a.Total.localeCompare(b.Total),
    },

    {
      title: "Status",
      dataIndex: "Status",
      render: (Status) => (
        <span className={`badge badge-${Status === 1 ? "warning" : "success"}`}>
          {Status === 1 ? "Booked" : "Sold"}
        </span>
      ),
      // sorter: (a, b) => (a.IsActive ? 1 : -1) - (b.IsActive ? 1 : -1),
    },

    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, Status) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className={`me-2 p-2 ${Status?.Status == 1 ? "" : "disabled"}`}
              title="Sold"
              onClick={(e) => {
                if (Status?.Status != 1) {
                  e.preventDefault(); 
                  return;
                }
                handleEditOrder(Status);
              }}
              style={{
                pointerEvents: Status?.Status == 1 ? "auto" : "none",
                opacity: Status?.Status == 1 ? 1 : 0.5,
                cursor: Status?.Status == 1 ? "pointer" : "not-allowed",
              }}
            >
              <i className="fa-solid fa-truck"></i>
            </Link>

            {/* <Link
                            className={`me-2 conform-text p-2 ${permissions.isRead}`}
                            to="#"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightSoldDeliChal"
                            aria-controls="offcanvasRightSoldDeliChal"
                        >
                            <i className="fa-regular fa-circle-check"></i>
                        </Link> */}
          </div>
        </td>
      ),
    },
  ];

  const filteredData = dataSource.filter(
    (item) =>
      (item && // Check if item is defined
        item.OrderNo &&
        item.OrderNo.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.CustomerName &&
        item.CustomerName.toLowerCase().includes(searchQuery.toLowerCase()))
    // (item.Description && item.Description.toLowerCase().includes(searchQuery.toLowerCase())) ||
    // (item.Qty && item.Qty.toString().includes(searchQuery.toLowerCase()))
  );

  const handleSubmit = (event, status) => {
    if (event) event.preventDefault();

    const orderDetails = selectedProduct.map((prod) => {
      const total = prod.quantity * prod.price;
      return {
        ProductId: prod.value,
        Quantity: 1,
        UnitPrice: prod.AvgPrice,
        Discount: 0,
        SGSTS: 18,
        CGSTS: 18,
        IGSTS: 0,
        Total: total,
        Status: status,
        RefundQuantity: 0,
        IsActive: 1,
        VendorId: 0,
        IsComplement: 0,
        CGSTrate: 9,
        SGSTrate: 9,
        IGSTrate: 0,
        NoOfBags: 0,
        Comments: mobileNumber,
        ItemWeight: prod.weight,
        ItemPackingWeight: 0,
        BilledBarCode: "NULL",
      };
    });

    // Calculate the total order amount
    const totalOrderAmount = orderDetails.reduce(
      (acc, prod) => acc + prod.Total,
      0
    );
    const currentDate = new Date();
    const requestPayload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      OrgType: 0,
      BillNo: null,
      Order: {
        StoreId: userDataSession.StoreId,
        PosId: 0,
        OrderType: 9,
        Total: totalOrderAmount,
        Discounts: 0,
        SGST: 9,
        CGST: 9,
        IGST: 18,
        Status: status,
        IsActive: 1,
        Orderdate: formatDate(currentDate),
        DiscountId: 0,
        DiningId: 0,
        ReturnFromOrdId: 0,
        CustomerId: 0,
        PriceListId: 0,
        TransportMode: "",
        TransportvehicleNumber: "",
        AdditionalCharges: 0,
        AdditionalRoundOffAmount: 0,
        IsAcknowledge: 0,
        TransportAmount: 0,
        InvoiceNo: "NULL",
        EmpId: userDataSession.UserId,
      },
      OrderDetails: orderDetails,
      OrderAdditionalDetails: selectedProduct.map((prod) => ({
        ProductId: prod.value,
        MakingCharges: null,
        OtherCharges: null,
        MetalRateId: null,
      })),
      OrderPayments: [
        {
          PaymentTypeId: null,
          PaidAmount: null,
          CardNo: "NULL",
          MobileNo: "NULL",
        },
      ],
      StockHistory: selectedProduct.map((prod) => ({
        ProductId: prod.value,
        StoreId: userDataSession.StoreId,
        StockEffectTypeId: 0,
        StockAdjusted: prod.quantity,
        TransactionId: 0,
        TransfarStockId: 0,
        StockAdjustId: 0,
        IsActive: 1,
        SupplierId: 0,
      })),
      StoreProducts: selectedProduct.map((prod) => ({
        ProductId: prod.value,
        StoreId: userDataSession.StoreId,
        StockAdjusted: -prod.quantity,
      })),
    };

    console.log(requestPayload, "data sending to service...");

    setSubmitBtnLoading(true);

    Axios.post(`${API_BASE_URL}${INSERT_ORDERS}`, requestPayload)
      .then((response) => {
        const data = response.data;
        console.log(data, "response data from API");
        setSubmitBtnLoading(false);
        if (data[0].OrderId >= 1) {
          Swal.fire({
            title: "Success",
            text: "Order added successfully.",
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to add order.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setSubmitBtnLoading(false);
        Swal.fire({
          title: "Error",
          text: "An error occurred while adding the order.",
          icon: "error",
        });
        console.error("Error:", error);
      });
  };



  const handleEditOrder = (order) => {
    console.log("handle order clicked", order);
    if (!order?.Id) return;

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this order?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
      cancelButtonText: "No, Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        Axios.post(`${API_BASE_URL}Billing/UpdateOrder`, {
          OrderId: order.Id,
          Status: 2,
          OrgId: userDataSession?.OrgId,
          UpdatedBy: userDataSession?.UserId,
        })
          .then((response) => {
            if (response.data.Status) {
              Swal.fire({
                icon: "success",
                title: "Order Updated",
                text: "The order was updated successfully.",

                showConfirmButton: true,
              }).then(() => {
                window.location.reload();
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Update Failed",
                text:
                  response.data.ResultMessage || "Unable to update the order.",
              });
            }
          })
          .catch((error) => {
            console.error("Error updating order:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong while updating the order.",
            });
          });
      }
    });
  };

  const handleDownloadExcel = () => {
    console.log(selectedProduct);
    if (data.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = dataSource?.map((item) => ({
      "Order Number": item.OrderNo,
      Date: item.Date,
      Customer: item.CustomerName,
      Total: item.Total,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "DelievryItems");

    // Save the workbook to a file
    XLSX.writeFile(wb, "DelievryItems.xlsx");
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Attendance Report",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = ["Number", "Date", "Customer", "Total"];
    tableData.push(headers);

    // Add rows
    dataSource.forEach((item) => {
      const row = [];
      row.push(item.OrderNo, item.Date, item.CustomerName, item.Ttal);
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("DelievryItems.pdf");
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Book-Sold Items</h4>
                <h6>Manage your items</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li className={` ${permissions.isExport}`} onClick={generatePDF}>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li
                className={` ${permissions.isExport}`}
                onClick={handleDownloadExcel}
              >
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className={`page-btn ${permissions.isRead}`}>
              <Link
                to="#"
                className="btn btn-added"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightSoldItem"
                aria-controls="offcanvasRightSoldItem"
              >
                <PlusCircle className="me-2" />
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="input-group search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <span className="input-group-text bg-white">
                      <i data-feather="search" className="feather-search"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                {loading ? (
                  // <div className="loader m-auto"></div>
                  <SpinLoader />
                ) : (
                  <Table columns={columns} dataSource={filteredData} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightSoldItem"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "36%", maxWidth: "36%" }}
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h4 id="offcanvasRightLabel" className="mb-0">
            Sold Product
          </h4>
          <div>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
        </div>
        <hr />
        <div className="offcanvas-body">
          <div id="pdf-content">
            <div className="row">
              {/* <div className="col-12">
                                <label className="form-label">Customer</label>
                                <input 
                                    type="text"
                                    className="form-control"
                                    value={selectedCustomer}
                                    onChange={(e) => setSelectedCustomer(e.target.value)}
                                    placeholder="Enter customer"
                                />
                            </div> */}
              <div className="col-12 mt-3">
                <label className="form-label">Product</label>
                <Select
                  options={productsData?.map((prod) => ({
                    value: prod,
                    label: prod.ProductName,
                  }))}
                  className="select"
                  placeholder="Select a product"
                  onChange={handleProductSelect}
                />
              </div>
              <div className="col-12 mt-3">
                <label className="form-label fw-semibold">Mobile Number</label>
                <input
                  type="tel"
                  className="form-control"
                  placeholder="Enter 10-digit mobile number"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  maxLength="10"
                  pattern="[0-9]{10}"
                  required
                />
              </div>

              <div className="d-flex justify-content-center align-items-center mt-4">
                <button
                  className="btn btn-info col-3 me-2"
                  onClick={(event) => handleSubmit(event, 1)}
                >
                  {submitBtnLoading ? "Booking.." : "Book"}
                  <i className="fa-regular fa-circle-check mt-1 ms-1"></i>
                </button>
                <button
                  className="btn btn-primary col-3"
                 onClick={(event) => handleSubmit(event, 2)}
                >
                  Sold
                  <i className="fa-regular fa-circle-check mt-1 ms-1"></i>
                </button>
              </div>
            </div>
            <div className=""></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BookedSoldItem;
